import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";

// Mock SVG icons (replace with your actual icons)
const MinimizeIcon = () => <span style={{ fontSize: "20px" }}>−</span>;
const ExpandIcon = () => <span style={{ fontSize: "20px" }}>+</span>;

const CustomAccordion = styled(Accordion)(({ theme }) => ({
  border: ".5px solid #e0e0e0",
  borderRadius: "30px !important",
  marginBottom: "10px",
  fontFamily: "figtree",
  boxShadow: "none",
  "&::before": {
    content: "none",
    display: "none",
  },
}));

const CustomAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  borderRadius: "25px",
  padding: "8px 20px",
  fontFamily: "figtree",
  minHeight: "48px",
  "& .MuiAccordionSummary-content": {
    margin: "4px 0",
  },
}));

const CustomAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  borderTop: "1px solid #e0e0e0",
  padding: "16px",
  color: "rgba(101, 101, 103, 1)",
  fontFamily: "figtree",
}));

const ScrollableContainer = styled(Box)(({ theme }) => ({
  maxHeight: "500px",
  overflowY: "auto",
  paddingRight: "8px",
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555",
  },
}));

const FaqList = ({ courseDetailsData }) => {
  const [expanded, setExpanded] = useState(false);

  // Handle case where courseDetailsData might be undefined or empty
  const faqData = courseDetailsData || [];
  
  // Check if we have more than 10 FAQs
  const hasMoreThanTen = faqData.length > 10;

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // Render all FAQs in a single container
  const renderFaqs = () => (
    <>
      {faqData.map((item, index) => (
        <CustomAccordion
          key={item._id || index} // Use _id if available, otherwise fallback to index
          expanded={expanded === index}
          onChange={handleChange(index)}
        >
          <CustomAccordionSummary
            expandIcon={expanded === index ? <MinimizeIcon /> : <ExpandIcon />}
            aria-controls={`${index}-content`}
            id={`${index}-header`}
          >
            <div style={{ fontWeight: 500, fontSize: "15px" }}>
              {item?.question}
            </div>
          </CustomAccordionSummary>
          <CustomAccordionDetails>
            <div style={{ fontWeight: 400, fontSize: "15px" }}>
              {item?.answer}
            </div>
          </CustomAccordionDetails>
        </CustomAccordion>
      ))}
    </>
  );

  // If no FAQs, don't render anything
  if (faqData.length === 0) {
    return null;
  }

  return (
    <>
      {hasMoreThanTen ? (
        <ScrollableContainer>{renderFaqs()}</ScrollableContainer>
      ) : (
        renderFaqs()
      )}
    </>
  );
};

export default FaqList;